export default __webpack_public_path__ + "static/BranchIllustration-1b2068a3e4f35099d31bdd047c2b6fb3.svg";